"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceCreateSchema = void 0;
var zod_1 = require("zod");
exports.WorkspaceCreateSchema = zod_1.z.object({
    name: zod_1.z.string().min(3).max(50),
});
